var v1="<div class=\"lbaLoader\" ng-if=\"vm.showLoader\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaLoader.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaLoader/lbaLoader.html
// module id = 200
// module chunks = 0